import gql from "graphql-tag";

import { pageInfoFragment } from "./pageInfo";

export const coverFragment = gql`
  fragment CoverFragment on Cover {
    id
    name
    title
    subtitle
    createDate
  }
`;

export const coverDetailsFragment = gql`
  ${coverFragment}
  ${pageInfoFragment}

  fragment CoverDetailsFragment on Cover {
    ...CoverFragment
    coverType
    firstImagePc
    firstImageMb
    firstImageLink
    firstImageText
    secondImagePc
    secondImageMb
    secondImageLink
    secondImageText
    thirdImagePc
    thirdImageMb
    thirdImageLink
    thirdImageText
    fourthImagePc
    fourthImageMb
    fourthImageLink
    fourthImageText
    detailImagePc
    detailImageMb
    detailImageLink
    detailImageText
    detailLinkTargetPc
    detailLinkTargetMb
    products(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
          productType {
            id
            name
          }
          isPublished
          thumbnail {
            url
          }
        }
      }
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
    }
    categories(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
          products {
            totalCount
          }
        }
      }
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
